<template>
  <div class="chat-widget__footer">
    <div class="chat-widget__footer-controls">
      <div class="chat-widget__footer-selects chat-widget__w-100">
        <SelectPreset v-if="appStore.showTemplates"/>
        <AssistantButton v-if="reference.assistants.length"/>
        <SelectModel v-if="appStore.showModels"/>
        <SelectUmlMode v-if="reference.uml_modes.length"/>
        <DomainFilterInput v-if="appStore.showSearchDomainFilter"/>
        <MusicTitleInput v-if="appStore.showMusicFields"/>
        <MusicTagsInput v-if="appStore.showMusicFields"/>
        <CheckWebSearch v-if="showWebSearch" />
      </div>
    </div>
    <InputArea/>
  </div>
</template>
<script setup>
import SelectPreset from "@/modules/chat/components/footer/SelectPreset.vue";
import SelectModel from "@/modules/chat/components/footer/SelectModel.vue";
import SelectUmlMode from "@/modules/chat/components/footer/SelectUmlMode.vue";
import {useAppStateStore} from "@/modules/chat/stores/appStore";
import {useReferenceStore} from "@/modules/chat/stores/referenceStore";
import DomainFilterInput from "@/modules/chat/components/footer/DomainFilterInput.vue";
import InputArea from "@/modules/chat/components/footer/InputArea.vue";
import MusicTitleInput from "@/modules/chat/components/footer/MusicTitleInput.vue";
import MusicTagsInput from "@/modules/chat/components/footer/MusicTagsInput.vue";
import AssistantButton from "@/modules/chat/components/assisstant/AssistantButton.vue";
import CheckWebSearch from "@/modules/chat/components/footer/CheckWebSearch.vue";
import {computed} from "vue";

const appStore = useAppStateStore();
const reference = useReferenceStore();

const showWebSearch = computed(() => appStore.canWebSearch());
</script>